import moment from "moment";
import { DATE_TIME } from "../../utilities/common";
import { Tooltip, TooltipProps } from "antd";

const DateTime = ({
  dateTime,
  showAgo = true,
  format = DATE_TIME.G_DATE_TIME_FORMAT,
  showTooltip = false,
  tooltipProps = {},
}: {
  dateTime: any;
  showAgo?: boolean;
  format?: string;
  showTooltip?: boolean;
  tooltipProps?: TooltipProps;
}) => {
  const localTime = moment(dateTime).local();
  const finalDateTime = showAgo
    ? localTime.fromNow()
    : localTime.format(format);

  return showTooltip ? (
    <Tooltip {...tooltipProps} title={localTime.format(format)}>
      {finalDateTime}
    </Tooltip>
  ) : (
    <>{finalDateTime}</>
  );
};

export default DateTime;
